module.exports = __webpack_public_path__ + "static/media/FET.6f08ff49.png";